module.exports = __webpack_public_path__ + "img/200.e55231a4.jpg";